<template>
    <div class="relative w-full h-full">
        <!-- Skeleton Loader -->
        <div
            v-if="loading"
            class="skeleton-loader"
        ></div>

        <!-- Actual Image -->
        <img
            :src="src"
            :alt="alt"
            @load="onLoad"
            @error="onError"
            class="image"
            :class="{ 'hidden': loading, 'fade-in': !loading }"
        />
    </div>
</template>

<script>
export default {
    props: {
        src: String,
        alt: {
            type: String,
            default: "Image",
        },
    },
    data() {
        return {
            loading: true,
            error: false,
        };
    },
    methods: {
        onLoad(event) {
            const img = event.target;

            if (img.complete && img.naturalHeight !== 0) {
                this.loading = false;
            }
        },
        onError() {
            this.loading = false;
            this.error = true;
        },
    },
};
</script>

<style scoped>
.relative {
    position: relative;
    display: inline-block;
    width: 100%;
    height: auto;
}

.skeleton-loader {
    width: 100%;
    height: 80px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 8px;
}

.image {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
}

.hidden {
    display: none;
}

.fade-in {
    opacity: 1;
}

@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }

    100% {
        background-position: 200% 0;
    }
}
</style>